import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { SlideFrame } from '../SlideFrame';
import { trustSteps, trustOutcomes, closingActions } from '../../data/deckContent';
export function AmbitionSlide() {
  const reduced = useReducedMotion();
  return <SlideFrame eyebrow="The habit" index={6} data-id="element-44" data-mp="20uy7hfaqqm2w">
      <div data-id="element-45" data-mp="20tn4hhp4dicu">
        <h2 className="max-w-[24ch] text-[clamp(20px,2.9vw,52px)] font-semibold leading-[1.06] tracking-tight text-white" data-id="element-46" data-mp="20tdbdl8s2v2x">
          From campaigns to a{' '}
          <span className="text-[color:var(--sv-green)]" data-id="element-47" data-mp="1rut4dhcky9uj">Solventum habit.</span>
        </h2>

        <div className="mt-[2.6vh] grid grid-cols-3 gap-[1.6vw]" data-id="element-48" data-mp="1cxirq4o7axx8">
          {trustSteps.map((step, i) => <motion.div key={step.order} initial={reduced ? false : {
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.32,
          delay: 0.06 * i,
          ease: [0.23, 1, 0.32, 1]
        }} className={`flex flex-col rounded-[1.2vw] border p-[1.5vw] ${i === 2 ? 'border-[color:var(--sv-green)]/45 bg-[color:var(--sv-green)]/10' : 'border-white/10 bg-white/[0.03]'}`} data-id="element-49" data-mp="1hvakf0wo6o2h" data-mpi={i}>
              <p className="text-[clamp(8px,0.82vw,15px)] font-medium uppercase tracking-[0.28em] text-[color:var(--sv-green)]" data-id="element-50" data-mp="2eh73m0kt7w95">
                {step.order}
              </p>
              <p className="mt-[1.2vh] text-[clamp(11px,1.25vw,24px)] font-light leading-snug text-white" data-id="element-51" data-mp="1lt1gx8a73x6o">
                {step.quote}
              </p>
              <p className="mt-auto pt-[1.4vh] text-[clamp(9px,0.85vw,16px)] font-light text-white/45" data-id="element-52" data-mp="1ztlzc3c77qzn">
                {step.text}
              </p>
            </motion.div>)}
        </div>

        <div className="mt-[2.4vh] flex flex-wrap items-center gap-[0.7vw]" data-id="element-53" data-mp="3b6oeqv2kaai8">
          {trustOutcomes.map(outcome => <span key={outcome} className="rounded-full border border-white/12 px-[1vw] py-[0.7vh] text-[clamp(9px,0.9vw,17px)] font-light text-white/60" data-id="element-54" data-mp="378h0c6vklla7">
              {outcome}
            </span>)}
        </div>

        <p className="mt-[2.6vh] text-[clamp(14px,1.8vw,34px)] font-medium leading-snug text-white" data-id="element-55" data-mp="2duprgc3tmwtz">
          A little time with Solventum should always{' '}
          <span className="text-[color:var(--sv-green)]" data-id="element-56" data-mp="1l4z6pk7oowow">pay back.</span>
        </p>

        <p className="mt-[1.6vh] flex flex-wrap gap-x-[0.6vw] text-[clamp(9px,0.95vw,18px)] font-light text-white/45" data-id="element-57" data-mp="1l362scoggqkl">
          {closingActions.map(action => <span key={action} data-id="element-58" data-mp="1u447yyamr44r">{action}</span>)}
        </p>
      </div>
    </SlideFrame>;
}